import { render, staticRenderFns } from "./CmgVerifyMobileNumberModal.vue?vue&type=template&id=6bdc482f&scoped=true&lang=pug&"
import script from "./cmg-verify-mobile-number-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-verify-mobile-number-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgVerifyMobileNumberModal.vue?vue&type=style&index=0&id=6bdc482f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc482f",
  null
  
)

export default component.exports